
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  head() {
    return {
      title:
        "Google Ads : comment bien choisir ses mots-clés pour vos annonces",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Apprenez à sélectionner intelligemment vos mots-clés pour vos annonces Google Ads afin d'atteindre votre audience et maximiser votre retour sur investissement.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "Annonce Google Ads : comment choisir ses mots-clés ?",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "Nicolas a créé un site Internet de qualité professionnelle. Pourtant, celui-ci n’apporte pas la visibilité sur Internet et la croissance qu’il voulait.",
        },
      ],
    };
  },
};
